import request from "@/services/request"

const api = {
    code: "/send_message",
    register: "/register",
    forget: '/forget_password',
    login: '/v1/login',
    config:'/v1/app-config'
}

/**
 * 发送验证码
 * @param {*} param0
 */
export function getCode(params) {
    return request({
        url: api.code,
        method: "get",
        params
    })
}

/**
 * 登录
 * @param {*} param0
 */
export function getLogin(params) {
    return request({
        url: api.login,
        method: "post",
        data: params
    })
}


/**
 * 注册
 */
export function getRegister(params) {
    return request({
        url: api.register,
        method: "get",
        params
    })
}


/**
 * 忘记密码
 */
export function getForget(params) {
    return request({
        url: api.forget,
        method: "get",
        params
    })
}

export function getConfigApi() {
    return request({
        url: api.config,
        method: "get",
    })
}